import { StatusIndicator, type StatusTone } from '@neo/primitives/status-indicator'
import { AgentState } from 'v2/pages/flow/types'

interface FlowStatusBadgeProps {
  state: AgentState | 'unsaved'
}

export const getFlowStatusBadgeVariant = (state: AgentState | 'unsaved') => {
  switch (state) {
    case AgentState.ACTIVE:
      return 'success'
    case AgentState.PAUSED:
      return 'warning'
    default:
      return 'default'
  }
}

export const getFlowStatusBadgeLabel = (state: AgentState | 'unsaved') => {
  switch (state) {
    case AgentState.ACTIVE:
      return 'Active'
    case AgentState.PAUSED:
      return 'Paused'
    case 'unsaved':
      return 'Unsaved'
    default:
      return 'Draft'
  }
}

const TONE: Record<ReturnType<typeof getFlowStatusBadgeVariant>, StatusTone> = {
  success: 'success',
  warning: 'warning',
  default: 'neutral',
}

export const FlowStatusBadge = ({ state }: FlowStatusBadgeProps) => {
  if (!state) return null
  return (
    <StatusIndicator tone={TONE[getFlowStatusBadgeVariant(state)]}>
      {getFlowStatusBadgeLabel(state)}
    </StatusIndicator>
  )
}
